<template>
  <div class="chat-container">
    <div ref="contenedorMensajes" class="scrollable-container">
      <div v-for="(bloque, i) in bloquesDeMensajes" :key="i">
        <div
            v-for="(msg, j) in bloque.mensajes"
            :key="j"
            class="mensaje-wrapper"
        >
          <Mensaje v-if="!loaderMensajes"
                   :usuario="bloque.usuario"
                   :mensaje="msg.mensaje"
                   :esUsuarioLab="bloque.esUsuarioLab"
                   :fecha="msg.fecha | formatoFechaHora"
                   :imagen="msg.imagenesBase64"
                   :posicion="obtenerPosicion(bloque.mensajes, j)"
                   :esPropio="bloque.idUsuario === idUsuario"
                   :mostrarIcono="bloque.idUsuario !== idUsuario && j === 0"
                   :mostrarNombre="j === 0"
          />
        </div>
      </div>
      <b-spinner variant="primary" label="spinner" v-if="loaderMensajes" style="position: absolute; top: 50%; left: 50%;"></b-spinner>
    </div>

    <div ref="contenedorInput" :class="['inputSearch', { 'focus-activo': isFocused }]">
      <div class="d-flex flex-column preview-container w-100">
        <div class="d-flex" v-if="imagenesPreview.length">
          <div
              class="preview-item m-2"
              v-for="(img, index) in imagenesPreview"
              :key="index"
          >
            <img :src="img.url" alt="img seleccionada" class="preview-img"/>
            <em class="circle_close" @click="eliminarImagen(index)"></em>
          </div>


        </div>
        <div
            ref="input"
            id="popover-etiquetar"
            class="editable-input"
            contenteditable="true"
            data-placeholder="Escriba un mensaje"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @input="handleInput"
            @keydown.enter.prevent="guardarMenciones"
            @keydown.backspace="handleBackspace"
            @keydown.down.prevent="navegarMenciones"
            @keydown.up.prevent="navegarMenciones"
        >

        </div>
      </div>

      <div class="d-flex align-items-center">
        <div class="d-flex justify-content-center" style="width: 30px !important; height: 2em !important;">
          <em class="attach" @click="abrirSelectorArchivos"></em>
          <input
              type="file"
              ref="inputArchivo"
              accept=".png, .jpeg, .jpg"
              style="display: none"
              @change="archivosSeleccionados"
          />
        </div>
        <div class="d-flex justify-content-center align-items-center"
             style="width: 30px !important; border-left: 1px solid gray; height: 1em !important; cursor: pointer">
          <em class="send" @click="guardarMensaje" v-if="!loaderGuardarMensaje"></em>
          <b-spinner variant="primary" label="spinner" small v-else></b-spinner>
        </div>
      </div>
    </div>


    <b-popover target="popover-etiquetar" :show.sync="pop1" triggers="manual">
      <div class="scrollable-tag">
        <div v-for="(sugerencia, index) in mencionesFiltradas" :key="index" class="sugerencia" style="line-height: 2; display: flex; gap: 5px"  @mousedown.prevent="seleccionarMencion(index)">
          <em :class="{ 'icon_dentalia icons-size': !sugerencia.esUsuarioLab, 'icon_laboratorio icons-size ': sugerencia.esUsuarioLab}"></em> <p>{{ sugerencia.nombreCompleto }}</p>
        </div>
      </div>
    </b-popover>


  </div>
</template>
<script>
import Mensaje from './Mensaje.vue';
import LocalStorageService from "@/services/LocalStorageService";
import {AwsService} from "@/apiServices/aws/AwsService";
import {DeleteObjectCommand, GetObjectCommand, S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";
import moment from "moment";

export default {
  name: "VistaChat",
  components: {
    Mensaje
  },
  props:{
    idClinica: Number,
    idLaboratorio: Number,
    ruta: String,
  },
  data() {
    return {
      imagenesPreview: [],
      isFocused: false,
      pop1: false,
      idUsuario: null,
      textoTemporal: '',
      mencionSeleccionada: 0,
      sugerencias: [],
      filter: '',
      mensaje: null,
      mencionesGuardadas: [],
      bloquesDeMensajes: [],
      loaderMensajes: false,

      token: null,
      awsServicio: new AwsService(),
      hoy: null,

      loaderGuardarMensaje: false,
    }
  },
  watch: {
    filter(newVal) {
      this.mencionesGuardadas = this.mencionesGuardadas.filter(m =>
          new RegExp(`@${m.nombre}\\b`).test(newVal)
      );
    },
    mensajes() {
      this.$nextTick(() => {
        const contenedor = this.$refs.contenedorMensajes;
        contenedor.scrollTop = contenedor.scrollHeight;
      });
    }
  },
  computed: {
    mencionesFiltradas() {
      const texto = this.textoTemporal.trim().toLowerCase();
      if (!texto) return this.sugerencias;
      return this.sugerencias.filter(s =>
          s.nombreCompleto.toLowerCase().startsWith(texto)
      );
    },

  },
  mounted() {


    this.obtenerMensajes();
  },

  async created() {
    this.idUsuario = LocalStorageService.getIdUsuario();
    this.traerUsuariosEtiqueta();

    //Funcionalidad AWS
    this.hoy = this.$moment().format("DD-MM-YYYY");
    this.token = this.$localStorageService.getTokenAWS();
    await this.validarTokenAWS();

  },
  methods: {
    handleInput() {
    const div = this.$refs.input;
    const text = div.innerText.trim();

    if (!text) {
      div.innerHTML = "";
    }

    this.revisar();
    this.onInput();
  },
  handleBackspace (e) {
      const sel = window.getSelection();
      if (!sel.rangeCount) return;

      const range = sel.getRangeAt(0);
      if (!range.collapsed) return;          

      /* cursor dentro de un span mencion*/
      if (
        range.startContainer.nodeType === 1 &&
        range.startContainer.classList &&
        range.startContainer.classList.contains('mencion')
      ) {
        e.preventDefault();
        const span = range.startContainer;
        const id   = span.getAttribute('data-id');
        span.remove();
        this.mencionesGuardadas = this.mencionesGuardadas.filter(
          m => String(m.idPersona) !== id
        );
        return;
      }

      /* cursor en el contenedor justo después del primer nodo - si la mención está pegada al borde izquierdo*/
      if (
      range.startContainer.nodeType === 1 &&   // DIV editable
      range.startOffset > 0                    // hay algo antes
    ) {
      const parent = range.startContainer;
      let   idx    = range.startOffset - 1;
      let   prev   = parent.childNodes[idx];

      // salta nodos de texto vacíos
      while (prev && prev.nodeType === 3 && !prev.nodeValue.trim().length) {
        prev = parent.childNodes[--idx];
      }

      if (prev && prev.classList && prev.classList.contains('mencion')) {
        e.preventDefault();
        const id = prev.getAttribute('data-id');
        prev.remove();
        this.mencionesGuardadas = this.mencionesGuardadas.filter(
          m => String(m.idPersona) !== id
        );
        return;
      }
    }


      /* cursor al inicio de un textNode */
      if (range.startContainer.nodeType === 3 && range.startOffset === 0) {

        // Salta textos vacíos para encontrar el nodo previo
        let prev = range.startContainer.previousSibling;
        while (prev && prev.nodeType === 3 && !prev.nodeValue.length) {
          prev = prev.previousSibling;
        }

        // mención es el primer nodo del editor
        if (!prev) {
          const first = range.startContainer.parentNode.firstChild;
          if (first && first.classList && first.classList.contains('mencion')) {
            e.preventDefault();
            const id = first.getAttribute('data-id');
            first.remove();
            this.mencionesGuardadas = this.mencionesGuardadas.filter(
              m => String(m.idPersona) !== id
            );
            return;
          }
        }

        // mención justo antes del cursor
        if (
          prev &&
          prev.classList &&
          prev.classList.contains('mencion')
        ) {
          e.preventDefault();
          const id = prev.getAttribute('data-id');
          prev.remove();
          this.mencionesGuardadas = this.mencionesGuardadas.filter(
            m => String(m.idPersona) !== id
          );
        }
      }
    },
    seleccionarMencion(index){
      this.mencionSeleccionada = index;
      this.guardarMenciones();
    },
    traerUsuariosEtiqueta(){
      const params = {
        idClinica: this.idClinica,
        idLaboratorio: this.idLaboratorio
      }
      this.$http.post(this.$api + "labs/odt/usuariosEtiqueta", params).then(response => {
        if (response.data.data) {
          this.sugerencias = response.data.data;
        }
      }).catch((err) => {
        console.info(err)
      });
    },
    abrirSelectorArchivos() {
      if (this.imagenesPreview.length > 0){
        this.$swal.fire({
          title: "Solo puede adjuntar 1 imagen por mensaje",
          icon: "warning",
        })
        return;
      }
      this.$refs.inputArchivo.click();
    },
    archivosSeleccionados(event) {
      const archivos = Array.from(event.target.files);

      const nuevasImagenes = archivos
          .filter(archivo => archivo.type.startsWith("image/"))
          .map(archivo => {
            // Extraer nombre y extensión del archivo
            // Preparar los datos del archivo
            const timestamp = this.$moment().format("YYYYMMDDHHmmssSSS");
            const nombreArchivo = 'COMENTARIO' + " " + timestamp;
            const extension = archivo.name.split('.').pop().toLowerCase();

            return {
              file: archivo, // Objeto File completo
              url: URL.createObjectURL(archivo), // URL para previsualización
              nombreArchivo: `${this.$route.params.idOdt}_${nombreArchivo}.${extension}`,
              extencion: extension.toLowerCase(),
            };
          });

      this.imagenesPreview.push(...nuevasImagenes);
      this.$refs.inputArchivo.value = ''; // Limpiar el input file
      event.target.value = '';
    },
    eliminarImagen(index) {
      URL.revokeObjectURL(this.imagenesPreview[index].url); // libera memoria
      this.imagenesPreview.splice(index, 1);
    },

    async guardarMensaje() {
      this.loaderGuardarMensaje = true;
      if (this.imagenesPreview.length > 0) {
        await this.guardarArchivos();
      }

      const params = {
        idOdt: Number(this.$route.params.idOdt),
        comentario: this.obtenerTextoMensaje(),
        idUsuario: this.idUsuario,
        archivosComentario: this.imagenesPreview,
        usuariosTag: this.mencionesGuardadas,
      }

      this.$http.post(this.$api + "odt/comentarios/send", params)
          .then(response => {
            if (response.data.data) {
              this.obtenerMensajes()
            }
          })
          .catch((err) => {
            console.error(err);
            if (this.imagenesPreview.length > 0) {
              this.eliminarArchivoAWS(this.imagenesPreview[0].urlRuta);
            }
          })
          .finally(() => {
            this.imagenesPreview.forEach(url => URL.revokeObjectURL(url));
            this.imagenesPreview = [];
            // Limpiar el input después de guardar
            this.$refs.input.innerHTML = '';
            this.loaderGuardarMensaje = false;
          });
    },

    // Metodo para eliminar archivos de AWS en caso de fallo en el backend
    async eliminarArchivoAWS(filePath) {
      try {
        const client = new S3Client({
          region: this.token.regionBucket,
          credentials: {
            accessKeyId: this.token.accessKeyId,
            secretAccessKey: this.token.secretAccessKey,
            sessionToken: this.token.sessionToken,
          },
        });

        await client.send(
            new DeleteObjectCommand({
              Bucket: this.token.nombreBucket,
              Key: filePath,
            })
        );

        console.log("Archivo eliminado de AWS:", filePath);
      } catch (awsError) {
        console.error("Error al eliminar archivo de AWS:", awsError);
      }
    },

    obtenerTextoMensaje() {
      const input = this.$refs.input;
      return input.innerText.trim();
    },

    guardarMenciones() {
      const mencion = this.mencionesFiltradas[this.mencionSeleccionada];
      if (!mencion) return;

      const selection = window.getSelection();
      if (!selection.rangeCount) return;

      const range = selection.getRangeAt(0);
      const container = range.startContainer;
      const offset = range.startOffset;

      // Asegurarse de que el nodo sea texto
      if (container.nodeType !== 3) return;

      const texto = container.textContent;
      const textoHastaCursor = texto.slice(0, offset);
      const match = textoHastaCursor.match(/@(\w*)$/);
      if (!match) return;

      const inicioMencion = match.index;
      const finMencion = offset;

      // Crear nuevo span
      const span = document.createElement('span');
      span.textContent = `@${mencion.nombreCompleto}`;
      span.className = 'mencion';
      span.setAttribute('data-id', mencion.idPersona);
      span.setAttribute('contenteditable', 'false');

      // Partir el texto original
      const antes = texto.slice(0, inicioMencion);
      const despues = texto.slice(finMencion);

      // Crear nuevos nodos
      const nodoAntes = document.createTextNode(antes);
      const nodoDespues = document.createTextNode(despues);

      const parent = container.parentNode;

      // Reemplazar el nodo original por: antes + span + después
      parent.replaceChild(nodoDespues, container);
      parent.insertBefore(span, nodoDespues);
      parent.insertBefore(nodoAntes, span);

      // Mover cursor después del span
      const espacio = document.createTextNode(' ');
      parent.insertBefore(espacio, nodoDespues);

      const newRange = document.createRange();
      newRange.setStartAfter(espacio);
      newRange.setEndAfter(espacio);
      selection.removeAllRanges();
      selection.addRange(newRange);

      this.mencionesGuardadas.push(mencion);
      this.pop1 = false;
      this.textoTemporal = '';
    },


    navegarMenciones(e) {
      if (!this.pop1) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.mencionSeleccionada = (this.mencionSeleccionada + 1) % this.mencionesFiltradas.length;
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        this.mencionSeleccionada =
            (this.mencionSeleccionada - 1 + this.mencionesFiltradas.length) % this.mencionesFiltradas.length;
      }
    },

    revisar() {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);

      if (!range || !range.startContainer || range.startContainer.nodeType !== 3) {
        this.textoTemporal = '';
        this.pop1 = false;
        return;
      }

      const containerText = range.startContainer.textContent;
      const cursorPos = range.startOffset;
      const textoHastaCursor = containerText.slice(0, cursorPos);
      const match = textoHastaCursor.match(/@(\w*)$/);

      if (match) {
        this.textoTemporal = match[1];
        this.mencionSeleccionada = 0;
        this.pop1 = true;
      } else {
        this.textoTemporal = '';
        this.pop1 = false;
      }
    },

    insertarMencion(nombre, idPersona) {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);

      const span = document.createElement('span');
      span.textContent = `@${nombre}`;
      span.className = 'mencion';
      span.setAttribute('data-id', idPersona);
      span.setAttribute('contenteditable', 'false');

      range.deleteContents();
      range.insertNode(span);
      range.setStartAfter(span);
      range.setEndAfter(span);
      selection.removeAllRanges();
      selection.addRange(range);

      this.mencionesGuardadas.push({nombre, idPersona});
      this.pop1 = false;
    },

    onInput() {
      const input = this.$refs.contenedorInput;
      // Actualiza menciones
      const spans = input.querySelectorAll('span.mencion');
      const idsEnTexto = Array.from(spans).map(span => span.getAttribute('data-id'));
      this.mencionesGuardadas = this.mencionesGuardadas.filter(m =>
          idsEnTexto.includes(String(m.idPersona))
      );
      this.ajustarAltura();
    },

    ajustarAltura() {
      const input = this.$refs.contenedorInput;
      const contenedorMensajes = this.$refs.contenedorMensajes;
      const chatContainer = this.$el;
      const alturaInput = input.offsetHeight;
      const alturaTotal = chatContainer.offsetHeight;

      // Le restamos la altura del input al total
      contenedorMensajes.style.height = `${alturaTotal - alturaInput}px`;
    },
    obtenerPosicion(mensajesDelBloque, index) {
      const anterior = mensajesDelBloque[index - 1];
      const siguiente = mensajesDelBloque[index + 1];

      const esInicio = !anterior;
      const esFin = !siguiente;

      if (esInicio && esFin) return 'inicio';
      if (esInicio) return 'inicio';
      if (esFin) return 'fin';
      return 'medio';
    },

    obtenerMensajes() {
      this.loaderMensajes = true;
      const params = {
        idOdt: Number(this.$route.params.idOdt),
      }
      this.$http.post(this.$api + "odt/comentarios/receive", params).then(async response => {
        if (response.data.data) {
          this.bloquesDeMensajes = response.data.data;
          await this.procesarImagenesEnMensajes();
          this.loaderMensajes = false;
          this.$nextTick(() => {
            const contenedor = this.$refs.contenedorMensajes;
            contenedor.scrollTop = contenedor.scrollHeight;
          });
          this.ajustarAltura();
        }
      });
    },

    async procesarImagenesEnMensajes() {
      await this.validarTokenAWS();

      // Configuración del cliente S3 (igual a tu versión)
      const config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      };
      const client = new S3Client(config);

      // Procesar todos los bloques de mensajes
      for (const bloque of this.bloquesDeMensajes) {
        // Procesar todos los mensajes del bloque
        for (const mensaje of bloque.mensajes) {
          // Verificar si hay imágenes para este mensaje
          if (mensaje.imagenes !== null) {
            mensaje.imagenesBase64 = null;

            try {
              const input = {
                Bucket: this.token.nombreBucket,
                Key: mensaje.imagenes,
              };

              const command = new GetObjectCommand(input);
              const response = await client.send(command);

              // Convertir el Body a blob y luego a Base64
              const responseS3 = await new Response(response.Body);
              const imageBlob = await responseS3.blob();
              const base64 = await this.convertBlobToBase64(imageBlob);

              // Agregar el Base64 al mensaje
              mensaje.imagenesBase64 = `data:${response.ContentType};base64,${base64}`;

            } catch (error) {
              console.error(`Error al procesar imagen ${mensaje.imagenes}:`, error);
              // Opcional: agregar un marcador de imagen fallida
              mensaje.imagenesBase64 = null;
            }

          } else {
            mensaje.imagenesBase64 = null;
          }
        }
      }
    },


    // Tu función existente para convertir blob a Base64
    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    //Funcionalidad AWS
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },

    async guardarArchivos() {
      try {
        await this.validarTokenAWS();

        const client = new S3Client({
          region: this.token.regionBucket,
          credentials: {
            accessKeyId: this.token.accessKeyId,
            secretAccessKey: this.token.secretAccessKey,
            sessionToken: this.token.sessionToken,
          },
        });

        const ruta = this.ruta.replace("#id_paciente", this.$route.params.idPaciente.toString());
        const nombreCarpeta = `ODT${this.$route.params.idOdt} ${this.hoy}`;
        const key = `${ruta}/${nombreCarpeta}/COMENTARIOS/${this.imagenesPreview[0].nombreArchivo}`;

        const upload = new Upload({
          client,
          params: {
            Bucket: this.token.nombreBucket,
            Key: key,
            Body: this.imagenesPreview[0].file,
            ContentType: this.imagenesPreview[0].file.type,
          },
          partSize: 5 * 1024 * 1024,
          queueSize: 4,
        });

        upload.on("httpUploadProgress", (progress) => {
          const porcentaje = Math.round((progress.loaded / progress.total) * 100);
          this.$set(this.imagenesPreview[0], "progreso", porcentaje);
        });

        await upload.done();

        this.imagenesPreview[0].urlRuta = key;

      } catch (error) {
        console.error("Error al subir archivo:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error al subir archivo",
          text: error.message || "No se pudo subir el archivo",
        });
        throw error;
      }
    }


  }
};
</script>

<style scoped>
 .mensaje-wrapper {
        display: flex;
        flex-direction: column;
    }
    .scrollable-container {
        overflow-y: auto;
        background-color: #FAFAFA;
        transition: height 0.2s ease;
        max-height: 93% !important;
    }

    .scrollable-tag {
        overflow-y: auto;
        max-height: 20vh;
    }

    .seleccion{
        background-color: paleturquoise;
    }

    .chat-mensajes {
        max-height: 100%;
        overflow-y: auto;
    }

    .chat-container {
        position: relative;
        height: 92%;
        display: flex;
        flex-direction: column;
        padding-bottom: 2%
    }

    .inputSearch {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: flex-end;
        border-top: 1px solid #ccc;
        background-color: #fff;
        gap: 0.5em;
        height: auto;
    }

    .editable-input {
        border: none;
        background-color: #ffffff;
        min-height: 2em;
        max-height: 8em;
        flex-grow: 1;
        text-align: left;
        padding: 0.25em 0.5em; 
        overflow-y: auto;
        resize: none;
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.2;
        font-size: 0.9em;
    }

    .editable-input:focus {
        outline: none;
    }

    .attach,
    .send {
        width: 1.1em;
    }

    .inputSearch.focus-activo {
        border-bottom: 2px solid #3e8ed0; 
        border-radius: 8px;
    }
    .preview-container {
        display: flex;
        flex-wrap: wrap;
        gap: 0.3em;
        margin-bottom: 0.3em;
    }

    .preview-img {
        width: 2.5em;
        height: 2.5em;
    }

    .preview-item {
  position: relative;
  display: inline-block;
}


.circle_close {
  position: absolute;
  top: -6px;
  right: -6px;

  width: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sugerencia:hover{
  background-color: pink;
  border-radius: 3px;
  color: palevioletred;

}

.editable-input:empty::before {
  content: attr(data-placeholder);
  color: #aaa;
  pointer-events: none;
}
</style>
